import React from 'react'

export interface ITopStripeTitle {
    title: string
}

const TopStripe: React.FC<ITopStripeTitle> = ({ title }) => {
    return (
        <div className="fixed flex top-0 justify-center items-center left-0 w-full h-12 bg-[#ff0000] border border-none text-white text-center z-50">
            {title}
        </div>
    )
}

export default TopStripe
